import { FunctionComponent, useMemo } from 'react'
import { useUpdateUserMetadataMutation } from '@/api/user-api'
import Tour, { type TourStep } from '@/components/common/tour'
import { useAuth } from '@/hooks/use-auth'
import useUserMetadata from '@/hooks/use-user-metadata'
import { useIntl } from '@/i18n/hooks/use-intl'

const VerifyEmailTour: FunctionComponent = () => {
  const { formatMessage } = useIntl()

  const { userInfo } = useAuth()
  const { userMetadata } = useUserMetadata()
  const [updateUserMetadata] = useUpdateUserMetadataMutation()

  const verifyEmailStep = useMemo((): TourStep[] => {
    return [
      {
        placement: 'topRight',
        title: formatMessage({ id: 'account:modify_common_email' }),
        description: formatMessage({
          id: 'account:modify_common_email_description',
        }),
        target: () =>
          document.querySelector<HTMLElement>('[data-tour-verify-email]'),
        nextButtonProps: {
          children: formatMessage({ id: 'general:btn_text_i_see' }),
        },
      },
    ]
  }, [formatMessage])

  const handleFinish = async (): Promise<void> => {
    if (userMetadata) {
      await updateUserMetadata({
        ...userMetadata,
        is_user_email_verified_tour_finished: true,
      })
    }
  }

  return (
    <Tour
      open={
        !userMetadata?.is_user_email_verified_tour_finished &&
        !userInfo?.emailConfirmed
      }
      steps={verifyEmailStep}
      onClose={handleFinish}
      onError={() => {}}
      onFinish={handleFinish}
    />
  )
}

export default VerifyEmailTour
